import { defineFcm } from '../shared/factory';

export const FCM_MAINTENANCE_BANNER = defineFcm('maintenance_banner').asString().withDefault(undefined).toConfig();
